import * as React from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap'
import moment from 'moment';
import { useAuth0 } from '../../auth/react-auth0-wrapper'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function PositionView({
    position,
    address,
    lastCommandResult,
    canCode,
    vehicle
}) {
    if (!position) return null;
    const { domains } = useAuth0();
    return (
        <Card className="card-box mb-2 mt-2">
            <CardHeader>
                <h4 className="font-size-lg mb-0 py-0 font-weight-bold">
                    Ultima posizione registrata
                </h4>
            </CardHeader>
            <CardBody className="px-4 pt-3">

                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <FontAwesomeIcon icon={['far', 'clock']}
                            className="font-size-lg d-block mr-3 text-dark opacity-5" />
                        <b className="text-dark">Orario</b>
                    </div>
                    <div className="font-weight-bold text-first font-size-lg">
                        {moment(position.deviceTime).format('DD/MM/YYYY HH:mm:ss')}
                    </div>
                </div>

                <div className="divider my-3" />

                <Row className="no-gutters">
                    <Col md="6">
                        <div className="d-flex align-items-center justify-content-between p-1">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={['fas', 'map-pin']}
                                    className="font-size-lg d-block mr-3 text-dark opacity-5" />
                                <b className="text-dark">Lat/Lon</b>
                            </div>
                            <div className="font-weight-bold text-first font-size-lg">
                                {position.latitude.toFixed(4)} / {position.longitude.toFixed(4)}
                            </div>
                        </div>
                    </Col>
                    <Col md="6">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={['far', 'map']}
                                    className="font-size-lg d-block mr-3 text-dark opacity-5" />
                                <b className="text-dark">Indirizzo</b>
                            </div>
                            <div className="font-weight-bold text-first font-size-lg">
                                {address}
                            </div>
                        </div>
                    </Col>
                </Row>

                <div className="divider my-3" />

                <Row className="no-gutters">
                    <Col md="6">
                        <div className="d-flex align-items-center justify-content-between p-1">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={['fas', 'mountain']}
                                    className="font-size-lg d-block mr-3 text-dark opacity-5" />
                                <b className="text-dark">Altitudine</b>
                            </div>
                            <div className="font-weight-bold text-first font-size-lg">
                                {position.altitude}
                            </div>
                        </div>
                    </Col>
                    <Col md="6">
                        <div className="d-flex align-items-center justify-content-between p-1">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={['fas', 'satellite']}
                                    className="font-size-lg d-block mr-3 text-dark opacity-5" />
                                <b className="text-dark">Satelliti</b>
                            </div>
                            <div className={`font-weight-bold font-size-lg text-${
                                position.attributes.sat >= domains.appSettings.satLimit ? 'success' : 'danger'
                                }`}>
                                {position.attributes.sat}
                            </div>
                        </div>
                    </Col>
                </Row>

                <div className="divider my-3" />

                <Row className="no-gutters">
                    <Col md="6">
                        <div className="d-flex align-items-center justify-content-between p-1">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={['fas', 'car-battery']}
                                    className="font-size-lg d-block mr-3 text-dark opacity-5" />
                                <b className="text-dark">Batteria veicolo</b>
                            </div>
                            <div className="font-weight-bold text-first font-size-lg">
                                {position.attributes.power ? position.attributes.power.toFixed(2) : ""}
                            </div>
                        </div>
                    </Col>
                    <Col md="6">
                        <div className="d-flex align-items-center justify-content-between p-1">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={['fas', 'battery-full']}
                                    className="font-size-lg d-block mr-3 text-dark opacity-5" />
                                <b className="text-dark">Batteria dispositivo</b>
                            </div>
                            <div className="font-weight-bold text-first font-size-lg">
                                {position.attributes.battery ? position.attributes.battery.toFixed(2) : ""}
                            </div>
                        </div>
                    </Col>
                </Row>

                <div className="divider my-3" />

                <Row className="no-gutters">
                    <Col md="6">
                        <div className="d-flex align-items-center justify-content-between p-1">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={['fas', 'tachometer-alt']}
                                    className="font-size-lg d-block mr-3 text-dark opacity-5" />
                                <b className="text-dark">Quadro</b>
                            </div>
                            <div className={`font-weight-bold font-size-lg text-${
                                position.attributes.di1 ? 'success' : 'primary'
                                }`}>
                                {position.attributes.di1 ? 'ACCESO' : 'SPENTO'}
                            </div>
                        </div>
                    </Col>
                    <Col md="6">
                        <div className="d-flex align-items-center justify-content-between p-1">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={['fas', 'lock']}
                                    className="font-size-lg d-block mr-3 text-dark opacity-5" />
                                <b className="text-dark">Avviamento</b>
                            </div>
                            <div className={`font-weight-bold font-size-lg text-${position.attributes.out1 ? 'danger' : 'success'}`}>
                                <FontAwesomeIcon icon={position.attributes.out1 ? ['fas', 'lock'] : ['fas', 'lock-open']} />{position.attributes.out1 ? ' BLOCCATO' : ' SBLOCCATO'}
                            </div>
                        </div>
                    </Col>
                </Row>

                <div className="divider my-3" />

                <Row className="no-gutters">
                    <Col md="3">
                        <div className="d-flex align-items-center justify-content-between p-1">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={['fas', 'network-wired']}
                                    className="font-size-lg d-block mr-3 text-dark opacity-5" />
                                <b className="text-dark">Linea CAN</b>
                            </div>
                            <div className="font-weight-bold text-first font-size-lg">
                                {canCode || `n.d.`}
                            </div>
                        </div>
                    </Col>
                    <Col md="3">
                        <div className="d-flex align-items-center justify-content-between p-1">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={['fas', 'temperature-high']}
                                    className="font-size-lg d-block mr-3 text-dark opacity-5" />
                                <b className="text-dark">Refrigerante</b>
                            </div>
                            <div className="font-weight-bold text-first font-size-lg">
                                {position.attributes.coolantTemp || `n.d.`}
                            </div>
                        </div>
                    </Col>
                    <Col md="3">
                        <div className="d-flex align-items-center justify-content-between p-1">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={['fas', 'gas-pump']}
                                    className="font-size-lg d-block mr-3 text-dark opacity-5" />
                                <b className="text-dark">Carburante (%)</b>
                            </div>
                            <div className="font-weight-bold text-first font-size-lg">
                                {position.attributes.fuel || `n.d.`} ({position.attributes.FuelPercentage || `n.d.`} %)
                            </div>
                        </div>
                    </Col>
                    <Col md="3">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={['fas', 'cogs']}
                                    className="font-size-lg d-block mr-3 text-dark opacity-5" />
                                <b className="text-dark">Giri motore</b>
                            </div>
                            <div className="font-weight-bold text-first font-size-lg">
                                {position.attributes.rpm || `n.d.`}
                            </div>
                        </div>
                    </Col>
                </Row>

                <div className="divider my-3" />

                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <FontAwesomeIcon icon={['far', 'comment-dots']}
                            className="font-size-lg d-block mr-3 text-dark opacity-5" />
                        <b className="text-dark">Esito ultimo comando</b>
                    </div>
                    <div className="font-weight-bold text-primary font-size-lg">
                        {lastCommandResult || ''}
                    </div>
                </div>

                <div className="divider my-3" />

                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <FontAwesomeIcon icon={['fas', 'car']}
                            className="font-size-lg d-block mr-3 text-dark opacity-5" />
                        <b className="text-dark">Veicolo</b>
                    </div>
                    <div className="font-weight-bold text-primary font-size-lg">
                        {`${vehicle.plate.toUpperCase()} - ${vehicle.attributes.preparation}`}
                    </div>
                </div>

            </CardBody>
        </Card>
    );
}
